import { Link, useParams } from "react-router-dom";
import React, { useState } from "react";
import { Button } from 'antd';
import axios from 'axios';

import DetailsCard from "./DetailsCard";
import AreaInfoCard from "./AreaInfoCard";
import BlockAndBuildingInfoCard from "./BlockAndBuildingInfoCard";
import LoadingIcon from "../LoadingIcon";
import MapCard from "./MapCard";
import Header from "../layout/Header";
import { getBackEndUrl } from "../BackEndUrl";
import { CopyOutlined } from "@ant-design/icons";

function Property() {
  let { id } = useParams();
  const initialPropertyData = {
    loaded: false,
    address: {
      propertyName: '',
      firstLineOfAddress: '',
      borough: '',
      city: '',
      country: '',
      postcode: '',
    },
    areaInfo: {
      localAuthority: '',
      ward: '',
      constituency: '',
      region: '',
      country: '',
    },
    blockAndBuildingInfo: {
      blockUprn: '',
      blockProperties: [],
    },
  };
  const [propertyData, setPropertyData] = useState(initialPropertyData);

  if (!propertyData.loaded) {
    let backEndUrl = getBackEndUrl();

    axios.get(backEndUrl + '/property/' + id).then(response => {
      const addressData = response.data.address;
      const areaInfoData = response.data.area_info;
      const blockInfoData = response.data.block_info;

      setPropertyData({
        loaded: true,
        address: {
          propertyName: addressData.property_name,
          uprn: addressData.uprn,
          firstLineOfAddress: addressData.first_line_of_address,
          borough: addressData.borough,
          city: addressData.city,
          country: areaInfoData.country,
          postcode: addressData.postcode,
        },
        areaInfo: {
          localAuthority: areaInfoData.local_authority,
          ward: areaInfoData.ward,
          constituency: areaInfoData.constituency,
          region: areaInfoData.region,
          country: areaInfoData.country,
        },
        blockAndBuildingInfo: {
          blockUprn: blockInfoData.block_uprn,
          blockProperties: blockInfoData.block_properties,
        },
      });
    });
  }

  return (
    <div className="App-property">
      <Header />
      <main className="App-property-main">
        <Link to="/" className="App-property-back">&larr; Back to search</Link>
        { propertyData.loaded
          ? (
            <div>
              <div className="App-property-title">
                <h1>{ propertyData.address.propertyName }</h1>
                <Button
                  id="copyUprnBig"
                  className="wmu-button"
                  shape="round"
                  icon={ <CopyOutlined /> }
                  size="large"
                  onClick={() => {navigator.clipboard.writeText(propertyData.address.uprn)}}
                >
                  Copy UPRN
                </Button>
              </div>
              <div className="App-property-body">
                <MapCard
                  firstLineOfAddress={ propertyData.address.firstLineOfAddress }
                  postcode={ propertyData.address.postcode }
                />
                <DetailsCard address={ propertyData.address }/>
                <AreaInfoCard areaInfo={ propertyData.areaInfo }/>
                <BlockAndBuildingInfoCard
                  propertyUprn={ propertyData.address.uprn }
                  blockInfo={ propertyData.blockAndBuildingInfo }
                />
              </div>
            </div>
          )
          : <LoadingIcon />
        }
      </main>
    </div>
  );
}

export default Property;
